"use client";

import { useEffect } from "react";
import { ErrorFallback } from "@/components/ErrorFallback";
import { isDOMManipulationError, reportDOMErrorToDatadog } from "@/utils/errorReporting";

/**
 * Error boundary for the QR Editor section.
 * This catches errors during SPA navigation including:
 * - "Failed to execute 'removeChild' on 'Node'" errors caused by third-party scripts
 * - DOM manipulation conflicts with VWO, GTM, react-svg, etc.
 */
export default function EditorError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Report error with full context to Datadog
    if (isDOMManipulationError(error)) {
      reportDOMErrorToDatadog(error, "editor");

      // For DOM errors, try automatic reset after a brief delay
      const timer = setTimeout(() => {
        reset();
      }, 100);
      return () => clearTimeout(timer);
    } else {
      console.error("Editor error caught:", error);
    }
  }, [error, reset]);

  return (
    <ErrorFallback
      onReset={reset}
      style={{ flex: 1, height: "calc(100dvh - 56px)", padding: "0px 1rem" }}
    />
  );
}
